<template>
  <div>
    <div
      class="restyle-mobile-layout"
      :class="{ 'restyle-mobile-layout--collapse': $store.state.showNav }"
      id="restyle-mobile-layout"
    >
      <div class="restyle-header-horizontal">
        <restyle_menu_mobile />
      </div>
      <div
        class="restyle-mobile-content-and-footer-overflow-wrapper scrollbar scrollbar--primary"
        ref="scroll"
      >
        <div
          v-show="!loadingStatus"
          class="restyle-mobile-content"
          :class="{ 'restyle-mobile-content--no-padding': $route.meta.noPadding }"
        >
          <slot></slot>
        </div>
        <PageLoaderMobile v-show="loadingStatus" />
        <div class="restyle-footer">
          <restyle_footer_mobile />
        </div>
      </div>
      <button v-if="isActiveScroll" class="scroll-top" @click="scrollTop">
        <img src="@/assets/icons/mobile_menu/button_top_page.svg" alt="">
      </button>
    </div>
  </div>
</template>

<script>
import restyle_menu_mobile from '@/components/restyle/restyle_menu/restyle_menu_mobile';
import restyle_footer_mobile from '@/components/restyle/restyle_menu/restyle_footer_mobile';
import restyle_header_mobile from '@/components/restyle/restyle_header/restyle_header_mobile';
import PageLoaderMobile from '@/components/restyle/loader/PageLoaderMobile.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'restyle-mobile-layout',
  components: {
    // restyle_menu,
    restyle_menu_mobile,
    restyle_header_mobile,
    restyle_footer_mobile,
    PageLoaderMobile,
  },
  data() {
    return {
      delay_var: false,
    };
  },
  watch: {
    $route() {
      this.$store.dispatch('loader/finishLoading');
    },
  },
  created() {
    const app = document.getElementById('app');
    app.style.width = '100%';
  },
  mounted() {
    this.$refs.scroll.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    this.$refs.scroll.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapMutations({
      setIsActiveScroll: "mobile_menu/SET_IS_ACTIVE_SCROLL",
      setCurrentPage: "mobile_menu/SET_CURRENT_PAGE",
    }),
    handleScroll(event) {
      const targetItem = event.target;
      if (targetItem.scrollTop > 0) {
        this.setIsActiveScroll(true)
      } else {
        this.setIsActiveScroll(false)
      }
    },
    scrollTop() {
      if (this.$refs.scroll.scrollTop > 0) {
        this.$refs.scroll.scrollTo(
          {
            top: 0,
            behavior: "smooth",
          }
        );
      }
      this.setIsActiveScroll(false);
    },
  },
  computed: {
    ...mapGetters({
      loadingStatus: 'loader/loadingStatus',
      isActiveScroll: "mobile_menu/GET_IS_ACTIVE_SCROLL",
      getCurrentPage: "mobile_menu/GET_CURRENT_PAGE",
    }),
  },
};
</script>

<style lang="scss">
@import '../assets/restyle/styles/reset.scss';
</style>

<style lang="scss" scoped>
$width_full: 291px;
$width_mini: 75px;

.restyle-mobile-layout {
  transition: all 0.6s ease;
}

.restyle-mobile-content {
  padding: 10px 10px 0 10px;
  display: flex;
  flex-direction: column;
  min-height: calc(100% - 32px);
  &--no-padding {
    padding: 0;
  }
}

.restyle-header-horizontal {
  z-index: 10;
  position: sticky;
  top: 0;
  height: 50px;
}
.restyle-footer {
  z-index: 2;
  padding: 0 30px;
  background: #1d1871;
  height: 32px;
}

.restyle-mobile-content-and-footer-overflow-wrapper {
  height: calc(100vh - 50px);
  overflow: auto;
}

.scroll-top {
  position: fixed;
  left: 15px;
  bottom: 15px;
  width: 32px;
  height: 32px;
}
</style>
